import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import size from "../Assets/Screenshot_2024-11-28_123540-removebg-preview.png";
import size1 from "../Assets/person.png";
import size2 from "../Assets/room.png";
import { baseUrl } from "../Common/data";
import useWishlist from "../hooks/useWishlist"; //  Import hook

function HotelCard() {
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const {
    wishlistIds,
    isInWishlist,
    toggleWishlist
  } = useWishlist(); // Use wishlist hook

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/selected-hotel/valid`);
        if (response.status === 200) {
          const shuffledHotels = shuffleArray(response?.data?.data?.hotels);
          setHotels(shuffledHotels);
        }
      } catch (error) {
        console.error("Error fetching hotels:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchHotels();
  }, []);

  console.log(hotels)

  const shuffleArray = (array) =>
    array
      .map((item) => ({ ...item, sortKey: Math.random() }))
      .sort((a, b) => a.sortKey - b.sortKey)
      .map(({ sortKey, ...rest }) => rest);

  const handleHotelClick = (id) => {
    window.open(`/collectiondetail/${id}`, "_blank");
  };

  const handleWishlistClick = async (e, hotelId) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) return alert("Please login to add to wishlist.");
    await toggleWishlist(hotelId); //  Centralized logic
  };

  return (
    <div className="trending-cards">
      {loading ? (
        <div className="loader"></div>
      ) : (
        hotels?.map((hotel) => (
          <div key={hotel?._id}>
            <div
              className="trending-card trending-card010"
              onClick={() => handleHotelClick(hotel?._id)}
            >
              <div
                className="wishlist-icon"
                onClick={(e) => handleWishlistClick(e, hotel?._id)}
              >
                <i
                  className={
                    isInWishlist(hotel?._id) ? "bi bi-heart-fill" : "bi bi-heart"
                  }
                ></i>
              </div>

              <img
                src={hotel?.images?.profile}
                alt={hotel?.propertyName}
                className="hotel-image"
              />
              <div className="trending-text">
                <h3>{hotel?.propertyName}</h3>
                <div className="trending-text-line">
                  <p>
                    <i className="bi bi-geo-alt-fill"></i> {hotel?.city}
                  </p>
                </div>
                <div className="trending-text-line2">
                <p>
                  {/* <img src={size1} alt="Guest capacity" />{" "} */}
                  {hotel?.guestCapacity} Guest ✦  {hotel?.totalRooms} {hotel?.totalRoomsType === "beds" ? "Beds" : "Rooms"}  ✦ {hotel?.poolSize?.length} X                   {hotel?.poolSize?.breadth} Pool
                </p>
                </div>
                <div className="trending-text-line">
                  {/* {hotel?.rates?.length > 0 && ( */}
                    <h2>
                      ₹ {hotel?.listingprice || ""} <span>/ {hotel?.priceType === "per_person" ? "Person" : "Night"}</span>
                    </h2>
                  {/* )} */}
                  <button>Book Now</button>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default HotelCard;
